export const closeSideContent = () => {
  return {
    type: "CLOSE_SIDE_CONTENT",
  };
};
